import React, { Fragment } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { NavMenu } from './NavMenu';
import { ArcaComponent } from './pages/ArcaComponent';
import { ArcaHttpSystem } from '../code/ArcaHttpSystem';

export class Banner extends ArcaComponent {

    constructor(props) {
        super(props);

        this.state = {
            atTop: true,
            highestPoint: null,
            position: null
        };
    }

    componentDidMount() {
        window.addEventListener("scroll", this.scroll.bind(this));
        var top = this.getTopOfPage();
        this.state.position = top;
        this.state.highestPoint = top;
    }

    componentWillUnMount() {
        window.removeEventListener("scroll", this.scroll);
    }

    scroll(e) {
        var top = this.getTopOfPage();
        var highestPoint = Math.max(this.state.highestPoint, top);

        if ((top === highestPoint) !== this.state.atTop) {
            ArcaHttpSystem.Log(`Changed: ${top === highestPoint}`)
            this.setState({
                position: top,
                highestPoint: highestPoint,
                atTop: (top === highestPoint)
            });
        }
    }

    getTopOfPage() {
        var element = document.getElementById('bottomOfBanner')
        var rect = element.getBoundingClientRect();

        return rect.top;
    }

    render() {
        ArcaHttpSystem.Log(`AtTop: ${this.state.atTop}`)
        return (
            <Fragment>
                <Container fluid className='navbar-fixed-top'>
                    <Row className='navRow'>
                        <Col>
                            <NavMenu isAtTop={this.state.atTop} />
                        </Col>
                    </Row>
                </Container>

                <span id='bottomOfBanner' />
            </Fragment>
        );
    }
}
